<template>
  <BaseNotification v-bind="attrs"
                    v-on="$listeners">
    <div v-if="message.length > 0"
         :style="containerStyle">
      <div :style="messageStyle">
        {{ message }}
      </div>
    </div>
  </BaseNotification>
</template>

<script>
  import BaseNotification from '@base/base-notification'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'NotificationPrimary',
    inheritAttrs: false,
    components: {
      BaseNotification,
    },
    data: function () {
      return {
        attrs: {
          bottom: 0,
        },
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '50px',
          justifyContent: 'center',
          width: '100%',
        },
        display: 'block',
        messageStyle: {
          borderRadius: Layout.space.sm,
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.lg,
          lineHeight: FontStyle.size.md,
          padding: `${Layout.space.md} ${Layout.space.lg}`,
          marginBottom: '2px',
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        ...this.$attrs,
      };
      this.messageStyle = {
        backgroundColor: this.color.warning1(),
        color: this.color.light1(),
        ...this.messageStyle,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapState({
        message: state => state.notification.warning,
      }),
    },
    watch: {
      message: function (newVal, oldVal) {
        this.display = newVal.length > 0 ? 'block' : 'none';
      },
    },
  };
</script>
